<template>
  <div>
    <!--    Loader-->
    <loading-panel :loading="loading"></loading-panel>
<!--    <base-button v-on:click="lightMode()">Light mode</base-button>-->
<!--    <base-button v-on:click="darkMode()">Dark mode</base-button>-->

    <div class="row">
      <div class="col">
        <card class="card-user">
          <div class="author mt-5">
            <div class="block block-one"></div>
            <div class="block block-two"></div>
            <div class="block block-three"></div>
            <div class="block block-four"></div>
            <a href="javascript:void(0)">
              <img v-if="company.img != null" class="avatar" :src="company.img" alt="..." />
              <img v-if="company.img == null" class="avatar" src="https://console.offthecouch.io/img/placeholder.jpg" alt="..." />
            </a>
            <div class="row mb-4">
              <div class="col text-center">
                <span class="btn btn-primary btn-sm btn-simple btn-file">Upload Company Logo
                  <input
                    accept="image/*"
                    @change="handleCompanyLogoUpload"
                    type="file"
                    name="..."
                    class="valid"
                    :multiple="false"
                    aria-invalid="false"
                  />
                </span>
              </div>
            </div>
          </div>
          <h3 slot="header" class="card-title">{{company_name}}</h3>

        </card>
      </div>
      <div class="col-lg-8">
        <card card-body-classes="table-full-width">
          <div class="row mb-3">
            <div class="col">
              <tab-rail
                :tabs="categories"
                :value="activeTabIndex"
                tight
                @input="switchTab"
              >
                <!-- Rendered on every tab and hidden with visibility so the rail keeps
                     one layout and one height when switching tabs -->
                <template v-if="hasPermissions('company_group_settings_configure')" #actions>
                  <base-button
                    :class="{ invisible: activeTabIndex !== 1 }"
                    size="sm"
                    type="primary"
                    v-on:click="createNewGroup()"
                  >
                    <i class="tim-icons icon-simple-add mr-2"></i>Create group</base-button>
                </template>
              </tab-rail>
            </div>
          </div>
          <div v-if="activeTabIndex === 0">
            <div class="row">
              <div class="col">
                <label>Company name</label>
                <base-input
                  type="text"
                  placeholder="Company name"
                  v-model="company.name"
                >
                </base-input>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-7">
                <base-input required label="Email"
                  type="text"
                  placeholder="Email"
                  v-model="company.email"
                  :error="errs.email"
                >
                </base-input>
              </div>
              <div class="col-lg-5">
                <base-input required
                  type="text"
                  label="Phone"
                  :error="errs.phone">
                  <phone-number-input ref="phoneInput"
                                      v-model="company.phone" @phone-update="handlePhoneUpdate"
                                      :default-country="countryCode || 'US'"
                  />
                </base-input>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <base-input required label="Address line 1"
                  type="text"
                  placeholder="Address line 1"
                  v-model="company.address"
                  :error="errs.address"
                >
                </base-input>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <label>Address line 2</label>
                <base-input
                  type="text"
                  placeholder="Address line 2"
                  v-model="company.address_line_2"
                >
                </base-input>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-3">
                <base-input required
                  type="text" :label="company.country.city_label"
                  :placeholder="company.country.city_label"
                  v-model="company.city"
                  :error="errs.city"
                >
                </base-input>
              </div>
              <div class="col">
                <base-input v-if="company.country.state_label === 'State'" :label="company.country.state_label">
                  <el-select
                    v-model="company.state"
                    class="select-primary"
                    name="email_group"
                    :placeholder="company.country.state_label"
                  >
                    <el-option
                      v-for="(s, i) in states"
                      class="select-primary"
                      :label="s.name"
                      :value="s.name"
                      :key="'S' + i"
                    ></el-option>
                  </el-select>
                </base-input>
                <base-input v-else :placeholder="company.country.state_label" :label="company.country.state_label" v-model="company.country.state"></base-input>
              </div>
              <div class="col-lg-3">
                <base-input required :label="company.country.zip_label"
                  type="text"
                  :placeholder="company.country.zip_placeholder"
                  v-model="company.zip"
                  :error="errs.zip"
                >
                </base-input>
              </div>
              <div class="col-3">
                <base-input label="Country">
                  <el-select
                             v-model="company.country"
                             class="select-primary"
                             name="email_group"
                             placeholder="Country"
                             value-key="code"
                  >
                    <el-option
                      v-for="(c, i) in countries"
                      class="select-primary"
                      :label="c.name"
                      :value="{name: c.name, code: c.code, city_label: c.city_label,
                      state_label: c.state_label, zip_placeholder: c.zip_placeholder, zip_label: c.zip_label,
                      phone_placeholder: c.phone_placeholder}"
                      :key="'C' + i"
                    ></el-option>
                  </el-select>
                </base-input>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6">
                <label>Social media</label>
                <base-input
                  type="text"
                  placeholder="Website"
                  addon-left-icon="fa fa-globe"
                  v-model="socials[4].link"
                >
                </base-input>
              </div>
              <div class="col-lg-6">
                <label>&nbsp;</label>
                <base-input
                  type="text"
                  placeholder="Facebook"
                  v-model="socials[0].link"
                  addon-left-icon="fab fa-facebook"

                >
                </base-input>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6">
                <base-input
                  type="text"
                  placeholder="Yelp"
                  v-model="socials[3].link"
                  addon-left-icon="fab fa-yelp"
                >
                </base-input>
              </div>
              <div class="col-lg-6">
                <base-input
                  type="text"
                  placeholder="Instagram"
                  addon-left-icon="fab fa-instagram"
                  v-model="socials[1].link"
                >
                </base-input>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6">
                <base-input
                  type="text"
                  placeholder="Twitter"
                  addon-left-icon="fab fa-twitter"
                  v-model="socials[2].link"
                >
                </base-input>
              </div>
              <div class="col-lg-6">
                <base-input
                  type="text"
                  placeholder="Tripadvisor"
                  v-model="socials[5].link"
                  addon-left-icon="fab fa-tripadvisor"
                >
                </base-input>
              </div>
            </div>
            <base-button v-on:click="saveCompanyData()" type="primary">
              Save changes
            </base-button>
          </div>

          <div v-if="activeTabIndex === 1">
            <filter-bar
              :filters="groupFilterSchema"
              :initial-value="groupFilters"
              :result-count="visibleGroups.length"
              :per-page="groupPerPage"
              :per-page-options="groupPerPageOptions"
              :sort-options="groupSortOptions"
              :sort-value="groupSort"
              :loading="loading"
              class="mb-3"
              @change="onGroupFiltersChanged"
              @update:sort="onGroupSortChange"
              @update:perPage="onGroupPerPageChange"
            />

            <!-- Empty state -->
            <div class="mt-3" v-if="groups.length <= 0 && groupFilters.archived === true">
              <div class="font-icon-detail">
                <span style="font-size: 3em; color: #9a9a9a">
                  <i class="tim-icons icon-square-pin"></i>
                </span>
                <h4 class="mt-3">No archived locations</h4>
              </div>
            </div>
            <div class="mt-3" v-else-if="groups.length > 0 && visibleGroups.length <= 0">
              <div class="font-icon-detail">
                <span style="font-size: 3em; color: #9a9a9a">
                  <i class="tim-icons icon-zoom-split"></i>
                </span>
                <h4 class="mt-3">No locations match these filters</h4>
              </div>
            </div>
            <div class="mt-3" v-else-if="groups.length <= 0">
              <div class="font-icon-detail">
                <span style="font-size: 3em; color: #9a9a9a">
                  <i class="tim-icons icon-square-pin"></i>
                </span>
                <h4 class="mt-3">No locations have been created</h4>
                <p class="text-muted mb-3">
                  Company groups help you organize games, staff, and settings by location.
                </p>
                <base-button
                  v-if="hasPermissions('company_group_settings_configure')"
                  type="primary"
                  size="sm"
                  @click="createNewGroup()">
                  <i class="tim-icons icon-simple-add mr-2"></i>
                  Create your first location
                </base-button>
              </div>
            </div>

            <!-- Desktop table view -->
            <div v-else-if="visibleGroups.length > 0" class="d-none d-sm-block">
              <div class="row table-full-width">
                <div class="col table-full-width">
                  <table class="table">
                    <thead>
                      <tr>
                        <th v-if="canReorderGroups" scope="col" style="width: 50px;"></th>
                        <th scope="col">Name</th>
                        <th scope="col">Events</th>
                        <th scope="col">Actions</th>
                      </tr>
                    </thead>
                    <tbody
                      tag="tbody"
                      v-model="draggableGroups"
                      is="draggable"
                      :disabled="!canReorderGroups"
                      handle=".drag-handle"
                      @start="isDraggingGroups = true"
                      @end="onGroupDragEnd"
                    >
                      <tr v-for="item in draggableGroups" :key="'CG' + item.id">
                        <td v-if="canReorderGroups" scope="row">
                          <span class="drag-handle" style="cursor: move;" aria-label="Drag to reorder">
                            <i class="tim-icons el-icon-rank"></i>
                          </span>
                        </td>
                        <td scope="row">
                          <div class="d-flex align-items-center">
                            <img class="round-img mr-3" :src="item.img || 'https://console.offthecouch.io/img/placeholder.jpg'"/>
                            <div>
                              <span class="card-title">{{item.name}}</span>
                              <badge v-if="item.copy_status === 'failed'" type="danger" class="ml-2">Copy failed</badge>
                              <div v-if="item.copy_status === 'copying'" class="mt-1">
                                <div class="progress-bar-container">
                                  <div class="progress-bar-striped"></div>
                                </div>
                                <small class="text-muted">Copying...</small>
                              </div>
                              <div v-else-if="activeJobByGroup[item.id]" class="mt-1">
                                <div class="progress-bar-container">
                                  <div class="progress-bar-striped"></div>
                                </div>
                                <small class="text-muted">{{ jobStepText(activeJobByGroup[item.id]) }}</small>
                              </div>
                            </div>
                          </div>
                        </td>
                        <td scope="row">
                          <template v-if="getGroupGames(item.games)[0] != null">
                            <badge v-for="(game, gIndex) in getGroupGames(item.games).slice(0, 3)" :key="gIndex" class="mr-2 mb-1" type="primary">
                              {{game.name}}
                            </badge>
                            <el-tooltip v-if="getGroupGames(item.games).length > 3"
                                        :content="getGroupGames(item.games).slice(3).map(g => g.name).join(', ')"
                                        effect="light"
                                        popper-class="otc-tooltip-popper"
                                        placement="top">
                              <badge type="default" class="mb-1">+{{ getGroupGames(item.games).length - 3 }} more</badge>
                            </el-tooltip>
                          </template>
                          <span v-else class="text-muted">No games assigned</span>
                        </td>
                        <td scope="row">
                          <span v-if="!hasPermissions('company_group_settings_configure') || item.copy_status === 'copying' || activeJobByGroup[item.id]">-</span>
                          <el-dropdown v-else>
                            <base-button
                              link
                              type="primary"
                              size="sm"
                            >
                              <i style="font-size: large" class="tim-icons el-icon-more"></i>
                            </base-button>
                            <template #dropdown>
                              <el-dropdown-menu>
                                <a v-if="groupFilters.archived === true" class="dropdown-item my-1" href="#" @click.prevent="unarchiveGroup(item)">
                                  <i class="tim-icons icon-refresh-02 mr-2"></i> Unarchive group
                                </a>
                                <template v-else>
                                  <template v-if="isGroupReady(item)">
                                    <a class="dropdown-item mt-1 mb-2" href="#" @click.prevent="editGroup(item)">
                                      <i class="tim-icons icon-pencil mr-2"></i> Edit group
                                    </a>
                                    <a class="dropdown-item mb-2" href="#" @click.prevent="copyGroup(item)">
                                      <i class="tim-icons icon-single-copy-04 mr-2"></i> Copy or merge
                                    </a>
                                    <div class="dropdown-divider"></div>
                                  </template>
                                  <a class="dropdown-item" :class="isGroupReady(item) ? 'mt-3 mb-0' : 'my-1'" href="#" @click.prevent="archiveGroup(item)">
                                    <i class="tim-icons icon-trash-simple mr-2"></i> {{ isGroupReady(item) ? 'Archive group' : 'Remove copy' }}
                                  </a>
                                </template>
                              </el-dropdown-menu>
                            </template>
                          </el-dropdown>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <!-- Mobile list view -->
            <div v-if="visibleGroups.length > 0" class="d-block d-sm-none">
              <table class="table">
                <tbody
                  tag="tbody"
                  v-model="draggableGroups"
                  is="draggable"
                  :disabled="!canReorderGroups"
                  handle=".drag-handle"
                  :delay="200"
                  :delayOnTouchOnly="true"
                  :touchStartThreshold="5"
                  @start="isDraggingGroups = true"
                  @end="onGroupDragEnd"
                >
                  <tr v-for="item in draggableGroups" :key="'CGM' + item.id">
                    <td class="py-3">
                      <div class="d-flex align-items-center">
                        <span v-if="canReorderGroups" class="drag-handle mr-2" style="cursor: move;">
                          <i class="tim-icons el-icon-rank"></i>
                        </span>
                        <img class="round-img-mobile mr-3" :src="item.img || 'https://console.offthecouch.io/img/placeholder.jpg'"/>
                        <div class="flex-grow-1">
                          <h4 class="mb-0">
                            {{item.name}}
                            <badge v-if="item.copy_status === 'failed'" type="danger" class="ml-2">Copy failed</badge>
                          </h4>
                          <div v-if="item.copy_status === 'copying'" class="mt-1">
                            <div class="progress-bar-container">
                              <div class="progress-bar-striped"></div>
                            </div>
                            <small class="text-muted">Copying...</small>
                          </div>
                          <div v-else-if="activeJobByGroup[item.id]" class="mt-1">
                            <div class="progress-bar-container">
                              <div class="progress-bar-striped"></div>
                            </div>
                            <small class="text-muted">{{ jobStepText(activeJobByGroup[item.id]) }}</small>
                          </div>
                          <small class="text-muted">
                            <template v-if="getGroupGames(item.games)[0] != null">
                              {{ getGroupGames(item.games).length }} game{{ getGroupGames(item.games).length !== 1 ? 's' : '' }}
                            </template>
                            <template v-else>No games</template>
                          </small>
                        </div>
                        <el-dropdown v-if="hasPermissions('company_group_settings_configure') && item.copy_status !== 'copying' && !activeJobByGroup[item.id]">
                          <button class="mobile-action-btn" aria-label="Actions">
                            <i class="tim-icons el-icon-more text-primary"></i>
                          </button>
                          <template #dropdown>
                            <el-dropdown-menu>
                              <a v-if="groupFilters.archived === true" class="dropdown-item my-1" href="#" @click.prevent="unarchiveGroup(item)">
                                <i class="tim-icons icon-refresh-02 mr-2"></i> Unarchive group
                              </a>
                              <template v-else>
                                <template v-if="isGroupReady(item)">
                                  <a class="dropdown-item mt-1 mb-2" href="#" @click.prevent="editGroup(item)">
                                    <i class="tim-icons icon-pencil mr-2"></i> Edit group
                                  </a>
                                  <a class="dropdown-item mb-2" href="#" @click.prevent="copyGroup(item)">
                                    <i class="tim-icons icon-single-copy-04 mr-2"></i> Copy or merge
                                  </a>
                                  <div class="dropdown-divider"></div>
                                </template>
                                <a class="dropdown-item" :class="isGroupReady(item) ? 'mt-3 mb-0' : 'my-1'" href="#" @click.prevent="archiveGroup(item)">
                                  <i class="tim-icons icon-trash-simple mr-2"></i> {{ isGroupReady(item) ? 'Archive group' : 'Remove copy' }}
                                </a>
                              </template>
                            </el-dropdown-menu>
                          </template>
                        </el-dropdown>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <b-pagination
              v-if="visibleGroups.length > groupPerPage"
              v-model="groupPage"
              :total-rows="visibleGroups.length"
              :per-page="groupPerPage"
              class="mt-3 mb-1"
            ></b-pagination>

            <base-alert-dialog
              :show="archiveDialog.show"
              :title="archiveDialog.group && isGroupReady(archiveDialog.group) ? 'Archive location?' : 'Remove failed copy?'"
              :message="archiveDialog.group && isGroupReady(archiveDialog.group)
                ? `${archiveDialog.group.name} will be archived with its events and settings. You can unarchive it later from the Archived filter.`
                : `${archiveDialog.group ? archiveDialog.group.name : ''} will be removed.`"
              variant="warning"
              show-cancel
              :confirm-text="archiveDialog.group && isGroupReady(archiveDialog.group) ? 'Archive' : 'Remove'"
              confirm-variant="danger"
              @confirm="confirmArchive"
              @cancel="archiveDialog.show = false"
            />

            <copy-group-drawer
              :show="copyDrawer.show"
              :group="copyDrawer.group"
              :groups="groups"
              :loading="copyDrawer.loading"
              :preview="copyDrawer.preview"
              :preview-loading="copyDrawer.previewLoading"
              :can-move="isAdmin"
              @close="copyDrawer.show = false"
              @copy="submitCopy"
              @preview="runPreview"
              @preview-reset="copyDrawer.preview = null"
              @run="submitJob"
            />
          </div>

<!--          API-->
          <div v-if="activeTabIndex === 2">
            <collapsible-section title="API key" icon="tim-icons icon-key-25" :collapsible="false">
              <info-hint variant="primary" style="width: 100%" class="mb-3">
                You must include the API key in the <code>X-API-Key</code> HTTP header in each authenticated request.
              </info-hint>
              <div v-if="api">
                <div class="row mt-2">
                  <div class="col-lg-4">
                    <label>ID</label>
                    <div class="credential-field">
                      <code>{{ api.api_id }}</code>
                      <i v-on:click="copy(api.api_id)" class="tim-icons icon-single-copy-04" title="Copy"></i>
                    </div>
                  </div>
                  <div class="col-lg-8">
                    <label>API key</label>
                    <div class="credential-field">
                      <code>{{ show_key ? api.api_key : maskedApiKey }}</code>
                      <span class="credential-field__action" v-on:click="show_key = !show_key">{{ show_key ? 'Hide' : 'Show' }}</span>
                      <i v-on:click="copy(api.api_key)" class="tim-icons icon-single-copy-04" title="Copy"></i>
                    </div>
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col">
                    <label>Creation date</label>
                    <p>{{getLocalDate(api.creation_date)}}, {{getLocalTime(api.creation_date)}}</p>
                  </div>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col">
                  <base-button variant="outlined" tone="primary" v-on:click="createAPIKeyPrompt()" v-if="api">
                    <i class="tim-icons icon-refresh-02"></i>Roll key
                  </base-button>
                  <base-button class="ml-2" variant="outlined" tone="primary" v-on:click="$router.push('/settings/api-requests')" v-if="api">
                    <i class="tim-icons icon-bullet-list-67"></i>View requests
                  </base-button>
                  <base-button type="primary" size="sm" v-on:click="createAPIKey()" v-if="!api">Create key</base-button>
                </div>
              </div>
            </collapsible-section>

            <webhooks-settings />
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import { Auth } from 'aws-amplify'
import { API_LOCATION } from '../../api-config'
import swal from 'sweetalert2'
const axios = require('axios')
import {Modal, ImageUpload, Badge, Card} from 'src/components'
import {BTable, BPagination} from "bootstrap-vue";
import {Dropdown, DropdownMenu} from 'element-ui';
import _ from "lodash";
import draggable from 'vuedraggable'
import {dayOfWeek, formattedDate, time} from "@/plugins/dateFormatter";
import {formatGroupDate, formatGroupTime} from "@/plugins/dates";
import countries from "@/assets/countries.json";
import states from "@/assets/states.json";
import PhoneNumberInput from '@/components/PhoneNumberInput.vue';
import WebhooksSettings from './WebhooksSettings.vue';
import TabRail from '@/components/TabRail.vue';
import CopyGroupDrawer from './CopyGroupDrawer.vue';
import FilterBar from '@/components/FilterBar.vue';
import { switchGroup } from '@/util/activeGroup';

  export default {
      name: "CompanySettings",
      components: {
        Modal,
        ImageUpload,
        Badge,
        BTable,
        BPagination,
        PhoneNumberInput,
        WebhooksSettings,
        draggable,
        TabRail,
        CopyGroupDrawer,
        FilterBar,
        [Dropdown.name]: Dropdown,
        [DropdownMenu.name]: DropdownMenu
      },
      data() {
        return {
          countryCode: JSON.parse(localStorage.getItem('company')).country,
          api: '',
          show_key: false,
          loading: false,
          customColWidth: 'col-lg-8 col-12',
          time_format: JSON.parse(localStorage.getItem('group')).time_format,
          date_format: JSON.parse(localStorage.getItem('group')).date_format,
          countries: countries.countries,
          states: states.states,
          activeTabIndex: 0,
          groups: [],
          totalGroupCount: 0,
          copyDrawer: { show: false, group: null, loading: false, preview: null, previewLoading: false },
          groupPollTimer: null,
          copyJobs: [],
          jobPollTimer: null,
          groupFilters: { name: '', events: [], archived: false },
          groupSort: { key: 'position', dir: 'asc' },
          groupSortOptions: [
            { key: 'position', label: 'Custom order' },
            { key: 'name', label: 'Name' },
          ],
          groupPage: 1,
          groupPerPage: 25,
          groupPerPageOptions: [10, 25, 50, 100],
          archiveDialog: { show: false, group: null },
          activeGroupCount: 0,
          isDraggingGroups: false,
          fields: ['name', 'games', 'actions'],
          socials: [
            {link: '', type_id: 1},
            {link: '', type_id: 2},
            {link: '', type_id: 3},
            {link: '', type_id: 4},
            {link: '', type_id: 5},
            {link: '', type_id: 6}
          ],
          company: {
            name: '',
            address: '',
            city: '',
            state: '',
            zip: '',
            img: '',
            phone: '',
            phoneE164: '',
            country:{
              "city_label": "City",
              "state_label": "State",
              "zip_label": "Zip",
              "zip_placeholder": "95133",
              "phone_placeholder": "(212) 555-1234"
            }
          },
          company_name: '',
          errs: {
            email: '',
            phone: '',
            address: '',
            city: '',
            zip: ''
          },
          uploadUrl: '',
          file: '',
          group: {
            name: '',
            img: '',
          },
        }
      },
      computed: {
        activeJobByGroup(){
          const out = {}
          for (const job of this.copyJobs) {
            if (!this.jobIsActive(job)) continue
            out[job.source_group_id] = job
            out[job.target_group_id] = job
          }
          return out
        },
        isAdmin(){
          try {
            const profile = JSON.parse(localStorage.getItem('profile') || 'null')
            return !!profile && profile.type === 'admin'
          } catch (e) {
            return false
          }
        },
        maskedApiKey() {
          const key = (this.api && this.api.api_key) || ''
          return '•'.repeat(16) + key.slice(-4)
        },
        categories() {
          return [
            { name: 'General settings', shortName: 'General' },
            { name: 'Company groups', shortName: 'Groups', count: this.activeGroupCount > 0 ? this.activeGroupCount : null },
            { name: 'API', shortName: 'API' },
          ];
        },
        // Drag reorder only when the whole list is on screen in its stored order:
        // every group loaded, no search or event filter, custom order sort, one page.
        canReorderGroups() {
          return this.groupFilters.archived !== true
            && !this.hasGroupListFilters
            && this.groupSort.key === 'position'
            && this.groups.length === this.totalGroupCount
            && this.groups.length <= this.groupPerPage
            && this.totalGroupCount > 1
            && this.hasPermissions('company_group_settings_configure')
        },
        hasGroupListFilters() {
          return !!this.groupFilters.name || (Array.isArray(this.groupFilters.events) && this.groupFilters.events.length > 0)
        },
        groupEventOptions() {
          const names = new Set()
          for (const g of this.groups) {
            for (const game of this.getGroupGames(g.games)) {
              if (game && game.name) names.add(game.name)
            }
          }
          return [...names].sort((a, b) => a.localeCompare(b)).map(n => ({ label: n, value: n }))
        },
        groupFilterSchema() {
          return [
            { key: 'name', type: 'text', label: 'Search', placeholder: 'Name or code', primary: true },
            { key: 'events', type: 'multiselect', label: 'Events', options: this.groupEventOptions, selectAll: true, primary: true },
            { key: 'archived', type: 'toggle', label: 'Archived', primary: true },
          ]
        },
        // Client-side filter and sort over the loaded list; the lambda returns every group.
        visibleGroups() {
          const term = (this.groupFilters.name || '').trim().toLowerCase()
          const events = Array.isArray(this.groupFilters.events) ? this.groupFilters.events : []
          let list = this.groups.filter(g => {
            if (term) {
              const name = (g.name || '').toLowerCase()
              const code = (g.code || '').toLowerCase()
              if (!name.includes(term) && !code.includes(term)) return false
            }
            if (events.length > 0) {
              // getGroupGames returns [null] for a group with no events
              const names = this.getGroupGames(g.games).filter(game => game && game.name).map(game => game.name)
              if (!events.some(e => names.includes(e))) return false
            }
            return true
          })
          if (this.groupSort.key === 'name') {
            list = [...list].sort((a, b) => (a.name || '').localeCompare(b.name || ''))
            if (this.groupSort.dir === 'desc') list.reverse()
          } else if (this.groupSort.dir === 'desc') {
            list = [...list].reverse()
          }
          return list
        },
        pagedGroups() {
          const start = (this.groupPage - 1) * this.groupPerPage
          return this.visibleGroups.slice(start, start + this.groupPerPage)
        },
        // vuedraggable needs a v-model: reading gives the current page, writing (only possible
        // while canReorderGroups, which means the page is the whole list) replaces the order.
        draggableGroups: {
          get() {
            return this.pagedGroups
          },
          set(value) {
            if (this.canReorderGroups) this.groups = value
          }
        }
      },
      methods: {
        hasPermissions(scope){
          let permissions = JSON.parse(localStorage.getItem('permissions'))
          const matchFound = permissions.some(element => element === scope);
          return matchFound
        },
        onGroupDragEnd() {
          this.isDraggingGroups = false
          this.updateGroupOrder()
        },
        async updateGroupOrder() {
          let token = await this.getAuthToken()
          let config = { headers: { Authorization: token } }
          let companyId = localStorage.getItem('companyId')
          let url = API_LOCATION + 'companies/' + companyId + '/groups'

          let data = {
            groups: this.groups.map((g, index) => ({
              id: g.id,
              position: index + 1
            }))
          }

          axios.put(url, data, config)
            .then(response => {
              this.$notify({
                type: 'success',
                message: 'Location order updated',
                icon: 'tim-icons icon-check-2'
              })
            })
            .catch(err => {
              console.log(err)
              if (err.response && err.response.status === 401) {
                this.$router.push('/forbidden')
              } else {
                this.$notify({
                  type: 'danger',
                  message: 'Could not update location order',
                  icon: 'tim-icons icon-alert-circle-exc'
                })
                this.getGroups()
              }
            })
        },
        createAPIKeyPrompt(){
          swal({
            title: 'Are you sure?',
            text: `Rolling will block this API key and generate a new one`,
            type: 'warning',
            showCancelButton: true,
          }).then((response)=> {
            if(response.value == true){
              this.createAPIKey()
            }
          })
        },
        async createAPIKey(){
          this.loading = true
          let token = await this.getAuthToken()
          let config = {headers: {Authorization: token}}
          let companyId = localStorage.getItem('companyId')
          let url = API_LOCATION + 'companies/' + companyId + '/api'

          let data = {}

          axios.post(url, data, config)
            .then(response => {
              this.loading = false
              swal('Success', 'New API key created' , 'success')
              this.getCompany()
            })
            .catch(err => {
              console.log(err)
              this.loading = false
              if(err.response.status == 401){
                this.$router.push('/forbidden')
              } else {
                swal('Error!', 'Something went wrong', 'error')
              }
            })
        },
        copy(item) {
          navigator.clipboard.writeText(item);
        },
        getDayOfWeek(d){
          console.log(d)
          if(JSON.parse(localStorage.getItem('group')).show_day_of_week){
            return dayOfWeek(d) + ', '
          }
          return ''
        },
        getLocalTime(d){
          return formatGroupTime(d)
        },
        getLocalDate(d){
          return formatGroupDate(d)
        },
        getTime(d) {
          return time(this.time_format, d)
        },
        getFormattedDate(d){
          return formattedDate(this.date_format, d)
        },
        switchTab(index){
          this.activeTabIndex = index
          if(this.activeTabIndex !== 0){
            this.customColWidth = 'col-lg-12'
          } else {
            this.customColWidth = 'col-lg-8 col-12'
          }
        },
        lightMode(){
          let docClasses = document.body.classList;
          docClasses.add('white-content');
        },
        darkMode(){
          let docClasses = document.body.classList;
          docClasses.remove('white-content');
        },
        async createNewGroup(){
          this.$router.push({ path: '/settings/group'})
        },
        isGroupReady(group){
          return !group.copy_status || group.copy_status === 'ready'
        },
        copyGroup(group){
          this.copyDrawer.group = group
          this.copyDrawer.show = true
        },
        async submitCopy(payload){
          this.copyDrawer.loading = true
          let token = await this.getAuthToken()
          let config = {headers: {Authorization: token}}
          let companyId = localStorage.getItem('companyId')
          let url = API_LOCATION + 'companies/' + companyId + '/groups/' + this.copyDrawer.group.id + '/copy'
          try {
            await axios.post(url, payload, config)
            this.copyDrawer.show = false
            this.$notify({ type: 'success', message: 'Copying location. This can take a minute.', icon: 'tim-icons icon-check-2' })
            await this.getGroups(true)
            this.startGroupPolling()
          } catch (err) {
            let message = 'Could not copy the location'
            let data = err.response && err.response.data
            if (typeof data === 'string') { try { data = JSON.parse(data) } catch (e) {} }
            if (data && data.validation_errors) {
              message = Object.values(data.validation_errors)[0]
            } else if (data && data.error) {
              message = data.error
            }
            this.$notify({ type: 'danger', message, icon: 'tim-icons icon-alert-circle-exc' })
          } finally {
            this.copyDrawer.loading = false
          }
        },
        startGroupPolling(){
          if (this.groupPollTimer) return
          if (!this.groups.some(g => g.copy_status === 'copying')) return
          this.groupPollTimer = setInterval(async () => {
            await this.getGroups(true)
            if (!this.groups.some(g => g.copy_status === 'copying')) {
              clearInterval(this.groupPollTimer)
              this.groupPollTimer = null
              if (this.groups.some(g => g.copy_status === 'failed')) {
                this.$notify({ type: 'danger', message: 'A location copy failed. Delete it and try again.', icon: 'tim-icons icon-alert-circle-exc' })
              } else {
                this.$notify({ type: 'success', message: 'Location copied', icon: 'tim-icons icon-check-2' })
              }
            }
          }, 5000)
        },
        // ─── OTC-3123: copy settings into an existing location, move events ───
        parseErrorMessage(err, fallback){
          let message = fallback
          let data = err && err.response && err.response.data
          if (typeof data === 'string') { try { data = JSON.parse(data) } catch (e) {} }
          if (data && data.validation_errors) {
            message = Object.values(data.validation_errors)[0]
          } else if (data && data.error) {
            message = data.error
          }
          return message
        },
        async runPreview(payload){
          this.copyDrawer.previewLoading = true
          this.copyDrawer.preview = null
          try {
            let token = await this.getAuthToken()
            let config = {headers: {Authorization: token}}
            let companyId = localStorage.getItem('companyId')
            let url = API_LOCATION + 'companies/' + companyId + '/groups/' + this.copyDrawer.group.id + '/copy'
            const response = await axios.post(url, { ...payload, dry_run: true }, config)
            this.copyDrawer.preview = response.data.preview
          } catch (err) {
            this.$notify({ type: 'danger', message: this.parseErrorMessage(err, 'Could not load the preview'), icon: 'tim-icons icon-alert-circle-exc' })
          } finally {
            this.copyDrawer.previewLoading = false
          }
        },
        async submitJob(payload){
          this.copyDrawer.loading = true
          try {
            let token = await this.getAuthToken()
            let config = {headers: {Authorization: token}}
            let companyId = localStorage.getItem('companyId')
            let url = API_LOCATION + 'companies/' + companyId + '/groups/' + this.copyDrawer.group.id + '/copy'
            await axios.post(url, payload, config)
            const target = this.groups.find(g => g.id === payload.target_group_id)
            const targetName = target ? target.name : 'the target location'
            const message = payload.mode === 'move'
              ? 'Merging into ' + targetName + '. This can take a few minutes.'
              : 'Copying settings into ' + targetName + '. This can take a minute.'
            this.copyDrawer.show = false
            this.copyDrawer.preview = null
            this.$notify({ type: 'success', message, icon: 'tim-icons icon-check-2' })
            await this.getCopyJobs()
            this.startJobPolling()
          } catch (err) {
            this.$notify({ type: 'danger', message: this.parseErrorMessage(err, 'Could not start the copy'), icon: 'tim-icons icon-alert-circle-exc' })
          } finally {
            this.copyDrawer.loading = false
          }
        },
        async getCopyJobs(){
          try {
            let token = await this.getAuthToken()
            let config = {headers: {Authorization: token}}
            let companyId = localStorage.getItem('companyId')
            const response = await axios.get(API_LOCATION + 'companies/' + companyId + '/copy-jobs?active=1', config)
            this.copyJobs = (response.data && response.data.jobs) || []
          } catch (err) {
            // The list still works without job state; the next poll retries.
          }
        },
        jobIsActive(job){
          return job.status === 'waiting' || job.status === 'running'
        },
        jobStepText(job){
          if (job.mode === 'move') return 'Merging...'
          return 'Copying settings...'
        },
        groupNameById(id){
          const g = this.groups.find(x => x.id === id)
          return g ? g.name : 'the location'
        },
        startJobPolling(){
          if (this.jobPollTimer) return
          if (!this.copyJobs.some(this.jobIsActive)) return
          const watched = new Set(this.copyJobs.filter(this.jobIsActive).map(j => j.id))
          this.jobPollTimer = setInterval(async () => {
            await this.getCopyJobs()
            if (this.copyJobs.some(this.jobIsActive)) return
            clearInterval(this.jobPollTimer)
            this.jobPollTimer = null
            await this.getGroups(true)
            for (const job of this.copyJobs.filter(j => watched.has(j.id))) {
              const targetName = this.groupNameById(job.target_group_id)
              if (job.status === 'ready') {
                const counts = job.counts || {}
                const message = job.mode === 'move'
                  ? 'Merged ' + this.groupNameById(job.source_group_id) + ' into ' + targetName + ' (' + (counts.events || 0) + ' event' + (counts.events === 1 ? '' : 's') + ', ' + (counts.orders || 0) + ' order' + (counts.orders === 1 ? '' : 's') + ')'
                  : 'Settings copied into ' + targetName
                this.$notify({ type: 'success', message, icon: 'tim-icons icon-check-2' })
                if (job.autoblock_error) {
                  this.$notify({ type: 'warning', message: 'Autoblocking could not run on ' + targetName + '. Run Clear resource assignments with reassignment there.', icon: 'tim-icons icon-alert-circle-exc' })
                }
              } else if (job.status === 'failed') {
                this.$notify({ type: 'danger', message: job.error || 'The copy failed', icon: 'tim-icons icon-alert-circle-exc' })
              }
            }
          }, 5000)
        },
        onGroupFiltersChanged(values){
          const archived = !!values && values.archived === true
          const archivedChanged = archived !== this.groupFilters.archived
          this.groupFilters = {
            name: (values && values.name) || '',
            events: values && Array.isArray(values.events) ? values.events : [],
            archived,
          }
          this.groupPage = 1
          if (archivedChanged) this.getGroups()
        },
        onGroupSortChange(sort){
          this.groupSort = sort && sort.key ? { key: sort.key, dir: sort.dir || 'asc' } : { key: 'position', dir: 'asc' }
          this.groupPage = 1
        },
        onGroupPerPageChange(value){
          this.groupPerPage = Number(value) || 25
          this.groupPage = 1
        },
        archiveGroup(group){
          this.archiveDialog.group = group
          this.archiveDialog.show = true
        },
        async confirmArchive(){
          const group = this.archiveDialog.group
          this.archiveDialog.show = false
          if (!group) return
          const ready = this.isGroupReady(group)
          this.loading = true
          let token = await this.getAuthToken()
          let config = {headers: {Authorization: token}}
          let companyId = localStorage.getItem('companyId')
          let url = API_LOCATION + 'companies/' + companyId + '/groups/' + group.id
          try {
            await axios.delete(url, config)
            this.$notify({ type: 'success', message: ready ? 'Location archived' : 'Copy removed', icon: 'tim-icons icon-check-2' })
            await this.getGroups()
          } catch (err) {
            this.loading = false
            if (err.response && err.response.status == 401) {
              this.$router.push('/forbidden')
            } else {
              this.$notify({ type: 'danger', message: ready ? 'Could not archive the location' : 'Could not remove the copy', icon: 'tim-icons icon-alert-circle-exc' })
            }
          }
        },
        async unarchiveGroup(group){
          this.loading = true
          let token = await this.getAuthToken()
          let config = {headers: {Authorization: token}}
          let companyId = localStorage.getItem('companyId')
          let url = API_LOCATION + 'companies/' + companyId + '/groups/' + group.id
          try {
            await axios.put(url, { unarchive: true }, config)
            this.$notify({ type: 'success', message: 'Location unarchived', icon: 'tim-icons icon-check-2' })
            await this.getGroups()
          } catch (err) {
            this.loading = false
            if (err.response && err.response.status == 401) {
              this.$router.push('/forbidden')
            } else {
              this.$notify({ type: 'danger', message: 'Could not unarchive the location', icon: 'tim-icons icon-alert-circle-exc' })
            }
          }
        },
        async changeDefaultGroup(group, opts = {}){
          try {
            await switchGroup(Number(group.id), group.name, opts)
          } catch (err) {
            this.loading = false
            // the switch did not happen, so the edit flag set for it must not linger
            localStorage.removeItem('editing')
            if (err && err.response && err.response.status == 401) {
              this.$router.push('/forbidden')
              return
            }
            this.$notify({ type: 'danger', message: 'Something went wrong' })
          }
        },
        async editGroup(group){
          // Set before switching: switchGroup navigates and nothing after it runs.
          localStorage.setItem('editing', 1)
          await this.changeDefaultGroup(group, { redirectTo: '/settings/group?id=' + group.id })
        },
        getAuthToken() {
          return new Promise(function (resolve) {
            Auth.currentSession()
              .then(data => {
                resolve(data.idToken.jwtToken)
              })
              .catch(err => console.log(err))
          })
        },
        getGroupGames(games) {
          if (!games) {
            return [null]
          }
          try {
            // If games is already an array, return it
            if (Array.isArray(games)) {
              return games
            }
            // Escape unescaped backslashes (backslashes not followed by valid JSON escape chars)
            let sanitized = games.replace(/\\(?!["\\/bfnrtu])/g, '\\\\')
            // Try parsing as-is first (in case it's already a valid JSON array)
            if (sanitized.trim().startsWith('[')) {
              return JSON.parse(sanitized)
            }
            // Otherwise wrap in brackets
            return JSON.parse('[' + sanitized + ']')
          } catch (e) {
            console.error('Error parsing games JSON:', e, games)
            return [null]
          }
        },
        async getSignedURL (file) {
          let token = await this.getAuthToken()
          let config = {headers: {Authorization: token}}
          let url = API_LOCATION + 'upload'

          let payload = {
            filePath: file.name,
            contentType: file.type
          }

          return new Promise ( function(resolve) {
            axios.post(url, payload, config)
              .then((res) => {
                resolve(res.data)
              })
              .catch((err) => {
                console.error(err)
              })
          })
        },
        async saveFile() {
          if(this.file != ''){
            this.uploadUrl = await this.getSignedURL(this.file)
            let uploaded = await this.uploadFile(this.file)
            //Get the image URL
            let imgUrl = this.uploadUrl.split("?")
            this.group.img = imgUrl[0]
            this.company.img = imgUrl[0]
          }
        },
        uploadFile (file) {
          let url = this.uploadUrl
          let config = { headers: {
              'Content-Type': file.type
            }}

          let payload = file
          return new Promise ( function(resolve) {
            axios.put(url, payload, config)
              .then((res) => {
                resolve(res)
              })
              .catch((err) => {
                console.error(err)
              })
          })
        },
        handleCompanyLogoUpload(){
          let file = event.target.files[0];
          this.company.img = URL.createObjectURL(file);
          this.file = file
          this.$emit('change', file);
        },
        async getCompany() {
          this.loading = true
          var token = await this.getAuthToken()
          let config = {headers: {Authorization: token}}
          let companyId = localStorage.getItem('companyId')
          let url = API_LOCATION + 'companies/' + companyId

          axios.get(url, config)
            .then(response => {
              this.company = response.data.company
              this.api = response.data.api
              this.company.country = _.find(this.countries, { code: this.company.country })
              this.company_name = response.data.company.name
              if(response.data.social_media.length > 0){
                this.socials = response.data.social_media
              }
              this.loading = false
            })
            .catch(err => {
              this.loading = false
              if(err.response.status == 401){
                this.$router.push('/forbidden')
              } else {
                swal('Error!', 'Something went wrong', 'error')
              }
            })
        },
        async getGroups(silent) {
          if (silent !== true) this.loading = true
          var token = await this.getAuthToken()
          let config = {headers: {Authorization: token}}
          let companyId = localStorage.getItem('companyId')
          const archivedView = this.groupFilters.archived === true
          let url = API_LOCATION + 'companies/' + companyId + '/groups' + (archivedView ? '?archived=1' : '')

          return axios.get(url, config)
            .then(response => {
              // Handle response as array or object with groups and total_group_count
              if (Array.isArray(response.data)) {
                this.groups = response.data
                this.totalGroupCount = response.data.length
              } else {
                this.groups = response.data.groups || []
                this.totalGroupCount = response.data.total_group_count || this.groups.length
              }
              if (!archivedView) this.activeGroupCount = this.groups.length
              this.loading = false
            })
            .catch(err => {
              this.loading = false
              if(err.response.status == 401){
                this.$router.push('/forbidden')
              } else {
                swal('Error!', 'Something went wrong', 'error')
              }
            })
        },
        handlePhoneUpdate(phoneData) {
          this.company.phoneE164 = phoneData.e164;
        },
        validCompanyFields() {
          let errors = 0

          if(!this.company.email || this.company.email.trim().length <= 0){
            this.errs.email = 'Email cannot be empty'
            errors++
          } else {
            this.errs.email = ''
          }

          let phone = this.company.phoneE164 || this.company.phone
          if(!phone || String(phone).trim().length <= 0){
            this.errs.phone = 'Phone cannot be empty'
            errors++
          } else {
            this.errs.phone = ''
          }

          if(!this.company.address || this.company.address.trim().length <= 0){
            this.errs.address = 'Address line 1 cannot be empty'
            errors++
          } else {
            this.errs.address = ''
          }

          if(!this.company.city || this.company.city.trim().length <= 0){
            this.errs.city = this.company.country.city_label + ' cannot be empty'
            errors++
          } else {
            this.errs.city = ''
          }

          if(!this.company.zip || String(this.company.zip).trim().length <= 0){
            this.errs.zip = this.company.country.zip_label + ' cannot be empty'
            errors++
          } else {
            this.errs.zip = ''
          }

          return errors > 0 ? false : true
        },
        async saveCompanyData() {
          if(!this.validCompanyFields()){
            return
          }
          this.editing = false
          this.loading = true
          await this.saveFile()
          var token = await this.getAuthToken()
          let config = {headers: {Authorization: token}}
          let companyId = localStorage.getItem('companyId')
          let url = API_LOCATION + 'companies/' + companyId

          let data = {
            address: this.company.address,
            address_line_2: this.company.address_line_2,
            city: this.company.city,
            country: this.company.country.code,
            state: this.company.state,
            zip: this.company.zip,
            phone: this.company.phoneE164 || this.company.phone,
            img: this.company.img,
            email: this.company.email,
            social_media: this.socials,
            name: this.company.name
          }

          axios.put(url, data, config)
            .then(response => {
              this.loading = false
              this.editing = false
              swal('Success', 'Company settings have been updated' , 'success')
              this.getCompany()
            })
            .catch(err => {
             console.log(err)
              this.loading = false
              if(err.response.status == 401){
                this.$router.push('/forbidden')
              } else {
                swal('Error!', 'Something went wrong', 'error')
              }
            })
        },
      },
      mounted () {
        this.getCompany()
        this.getGroups().then(() => this.startGroupPolling())
        this.getCopyJobs().then(() => this.startJobPolling())
        if (this.$route.query.tab !== undefined) {
          this.switchTab(Number(this.$route.query.tab));
        }
      },
      beforeDestroy () {
        if (this.groupPollTimer) {
          clearInterval(this.groupPollTimer)
          this.groupPollTimer = null
        }
        if (this.jobPollTimer) {
          clearInterval(this.jobPollTimer)
          this.jobPollTimer = null
        }
      },
      watch: {
        '$route.query.tab'(newTab) {
          if (newTab !== undefined) {
            this.switchTab(Number(newTab));
          }
        }
      }
    }
</script>

<style scoped>
  .round-img {
    width: 60px;
    height: 60px;
    -webkit-border-radius: 60px;
    -webkit-background-clip: padding-box;
    -moz-border-radius: 60px;
    -moz-background-clip: padding;
    border-radius: 60px;
    background-clip: padding-box;
    background-size: cover;
    background-position: center center;
    object-fit: cover;
  }

  .round-img-mobile {
    width: 50px;
    height: 50px;
    border-radius: 50px;
    background-size: cover;
    background-position: center center;
    object-fit: cover;
  }

  .drag-handle {
    padding: 8px;
    color: #9a9a9a;
    transition: color 0.2s ease;
  }

  .drag-handle:hover {
    color: #e14eca;
  }

  .sortable-ghost {
    opacity: 0.5;
    background: rgba(225, 78, 202, 0.1);
  }

  .sortable-chosen {
    background: rgba(225, 78, 202, 0.05);
  }

  .mobile-action-btn {
    width: 44px;
    height: 44px;
    border-radius: 8px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    background: transparent;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.1rem;
    cursor: pointer;
  }

  .mobile-action-btn:active {
    background: rgba(255, 255, 255, 0.1);
  }
</style>
